export type ApplianceTypesProps = {
  hasConvectionOven: boolean;
  hasDishwasher: boolean;
  hasDoubleOven: boolean;
  hasDryer: boolean;
  hasFreezer: boolean;
  hasGarbageDisposal: boolean;
  hasMicrowaveOven: boolean;
  hasOven: boolean;
  hasRange: boolean;
  hasRefrigerator: boolean;
  hasTrashCompactor: boolean;
  hasWasher: boolean;
  hasWasherDryerHookups: boolean;
};

const ApplianceTypes = ({
  hasConvectionOven = false,
  hasDishwasher = false,
  hasDoubleOven = false,
  hasDryer = false,
  hasFreezer = false,
  hasGarbageDisposal = false,
  hasMicrowaveOven = false,
  hasOven = false,
  hasRange = false,
  hasRefrigerator = false,
  hasTrashCompactor = false,
  hasWasher = false,
  hasWasherDryerHookups = false,
}: Partial<ApplianceTypesProps> = {}): ApplianceTypesProps => ({
  hasConvectionOven: Boolean(hasConvectionOven),
  hasDishwasher: Boolean(hasDishwasher),
  hasDoubleOven: Boolean(hasDoubleOven),
  hasDryer: Boolean(hasDryer),
  hasFreezer: Boolean(hasFreezer),
  hasGarbageDisposal: Boolean(hasGarbageDisposal),
  hasMicrowaveOven: Boolean(hasMicrowaveOven),
  hasOven: Boolean(hasOven),
  hasRange: Boolean(hasRange),
  hasRefrigerator: Boolean(hasRefrigerator),
  hasTrashCompactor: Boolean(hasTrashCompactor),
  hasWasher: Boolean(hasWasher),
  hasWasherDryerHookups: Boolean(hasWasherDryerHookups),
});

export default ApplianceTypes;
